import { GzEasmCertificateExpirationWebComponent } from './component/GzEasmCertificateExpirationWebComponent';

export { GzEasmCertificateExpirationWebComponent };
